<template>
  <div class="main-contaienr">
    <el-row>
      <el-col :span="5">
        <!-- 售票数量统计 -->
        <div class="ticket1 leftchild">
          <mark-column title="售票数量统计">
            <div class="progress-group">
              <div
                class="progress-item"
                v-for="(item, index) in ticketList.progress"
                :key="index"
              >
                <ticket-progress :item="item"></ticket-progress>
              </div>
            </div>
          </mark-column>
        </div>
        <!-- 售票趋势统计 -->
        <div class="sell leftchild">
          <mark-column title="售票趋势统计">
            <ticket-trend></ticket-trend>
          </mark-column>
        </div>
      </el-col>
      <!-- 中间地图部分 -->
      <el-col :span="14"><ticket-map></ticket-map></el-col>
      <el-col :span="5" class="bottom">
        <!-- 票务检票时间分布 -->
        <div class="ticket">
          <mark-column title="票务检票时间分布">
            <div class="progress-group">
              <div class="progress-item">
                <inspection-time></inspection-time>
              </div>
            </div>
          </mark-column>
        </div>
        <!-- 票务月度售票趋势对比 -->
        <div class="ticket sell">
          <mark-column title="票务月度售票趋势对比">
            <div class="progress-group">
              <div class="progress-item">
                <monthly-contrast></monthly-contrast>
              </div>
            </div>
          </mark-column>
        </div>
      </el-col>
      <el-col :span="6" class="bottom">
        <!-- 游客来源省份TOP5 -->
        <div class="tourist">
          <mark-column title="游客来源省份TOP5">
            <div class="progress-group">
              <div class="progress-item">
                <tourist-one></tourist-one>
              </div>
            </div>
          </mark-column>
        </div>
      </el-col>
      <el-col :span="6" class="bottom">
        <!-- 游客省内来源地市 -->
        <div class="tourist">
          <mark-column title="游客省内来源地市">
            <div class="progress-group">
              <div class="progress-item">
                <tourist-two></tourist-two>
              </div>
            </div>
          </mark-column>
        </div>
      </el-col>
      <el-col :span="6" class="bottom">
        <!-- 热门票种TOP5 -->
        <div class="tourist">
          <mark-column title="热门票种TOP5">
            <div class="progress-group">
              <div class="progress-item">
                <tourist-three></tourist-three>
              </div>
            </div>
          </mark-column>
        </div>
      </el-col>
      <el-col :span="6" class="bottom">
        <!-- 票务售票渠道TOP5 -->
        <div class="tourist">
          <mark-column title="票务售票渠道TOP5">
            <div class="progress-group">
              <div class="progress-item">
                <tourist-four></tourist-four>
              </div>
            </div>
          </mark-column>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  //导入标题栏
  import markColumn from './components/mark-column'
  // 导入售票数量统计
  import ticketProgress from './components/ticket-progress'
  //导入中间地图
  import ticketMap from './components/ticket-map'
  //票务检查时间
  import inspectionTime from './components/inspection-time'
  //票务月度售票趋势对比
  import monthlyContrast from './components/monthly-contrast'
  //游客来源省份TOP5
  import touristOne from './components/tourist-one'
  //游客省内来源地市
  import touristTwo from './components/tourist-two'
  //热门票种TOP5
  import touristThree from './components/tourist-three'
  //票务售票渠道TOP5
  import touristFour from './components/tourist-four'
  //售票趋势统计
  import ticketTrend from './components/ticket-trend'

  export default {
    components: {
      markColumn,
      ticketProgress,
      ticketTrend,
      ticketMap,
      inspectionTime,
      monthlyContrast,
      touristOne,
      touristTwo,
      touristThree,
      touristFour,
    },
    data() {
      return {
        // 今日检票
        ticketList: {
          progress: [
            {
              name: '今日售票',
              total: 200,
              number: 110,
              color: ['#004743', '#5CFFF5'],
            },
            {
              name: '七日售票',
              total: 1000,
              number: 568,
              color: ['#003447', '#00A8FF'],
            },
            {
              name: '月售票',
              total: 1000,
              number: 425,
              color: ['#473400', '#FFC600'],
            },
            {
              name: '年售票',
              total: 10000,
              number: 5698,
              color: ['#271148', '#A525FF'],
            },
          ],
        },
      }
    },
    mounted() {
      // this.init()
    },
    beforeDestroy() {
      this.$animejs.remove(['.svg-container', '.leftchild', '.right'])
    },
    methods: {
      // 初始化
      init() {
        let anime = this.$animejs
        // anime({
        //   targets: '.leftchild',
        //   translateX: [-600, 0],
        //   scale: [0, 1],
        //   easing: 'easeInOutSine',
        //   delay: anime.stagger(100),
        // })
        anime({
          targets: '.bottom',
          translateY: [-100, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: 300,
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .main-contaienr {
    // 售票数量统计
    .ticket {
      height: 27.024vh;
    }

    .ticket1 {
      height: 26vh;
    }
    .sell_ickets {
      // height: 20vh;
    }
    .sell {
      margin-top: 4vh;
    }
    .tourist {
      height: 12vh;
    }
  }
</style>
